<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form ref="form" :model="listMenuForm" class="searchForm">

            <el-form-item label="訂單編號" class="searchItem">
              <el-input v-model="listMenuForm.orderId" @change="listMenuForm.orderId=listMenuForm.orderId.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,'')"></el-input>
            </el-form-item>

            <el-form-item label="用戶賬號" class="searchItem">
              <el-input v-model="listMenuForm.userAccount" @change="listMenuForm.userAccount=listMenuForm.userAccount.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\$%\^&\*\\\/]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="支付方式" class="searchItem">
              <el-select v-model="listMenuForm.payWay"  placeholder="請選擇支付方式">
              <el-option label="esunbank-AliPay" value="1"></el-option>
              <el-option label="Paypal" value="2"></el-option>
              <el-option label="ecpay" value="3"></el-option>
              <el-option label="銀行匯款" value="5"></el-option>
              <el-option label="支付寶" value="6"></el-option>
              <el-option label="微信" value="7"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="貨運單號" class="searchItem hidden-lg-and-down">
              <el-input
                v-model="listMenuForm.logisticsId"
                maxlength="18"
                @change="listMenuForm.logisticsId=listMenuForm.logisticsId.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,'')"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form class="searchForm">
            <el-form-item label="貨運單號" class="searchItem hidden-xl-only">
              <el-input
                v-model="listMenuForm.logisticsId"
                maxlength="18"
                @change="listMenuForm.logisticsId=listMenuForm.logisticsId.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,'')"></el-input>
            </el-form-item>

             <el-form-item v-if="questionOption.length > 0" label="問題類型" class="searchItem">
              <el-select v-model="listMenuForm.wrongType"  placeholder="請選擇問題類型">
                <el-option label="全部" value=""></el-option>

                <el-option
                  v-for="(item,index) in questionOption"
                  :key="'label'+index"
                  :label=item.questionKind :value=item.id></el-option>
              </el-select>
            </el-form-item>

          </el-form>
        </el-col>

      </el-row>

      <div class="MenuBtnWrap" style="justify-content:space-between;">
        <div style="display:flex;">
            <div class="btn" @click="exportExcel">下載問題訂單Excel</div>
        </div>

        <div style="display:flex;">
            <div class="btn" @click="search">查詢</div>
            <div class="btn borderBtn" @click="reset">重置</div>
        </div>

      </div>
      <div class="tableWrap orderListTable">
        <el-table :data="orderList" style="width:100%;"  height='660px' stripe border>
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            type="index"
            label="#"
            width="50">
          </el-table-column>
          <el-table-column
            v-for="(item, index) in orderTable" :key="'label'+index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop]&& scope.row[item.prop]!==0">-</div>
              <div v-else-if="item.prop === 'username'">
                <div>{{scope.row.realName}}</div>
                <div :style="{color:'#6C3DEA',cursor:'pointer'}" @click="$router.push('/userDetails?id=' + scope.row.userId+'&status=problem')">{{scope.row.username}}</div>
              </div>
              <div v-else-if="item.prop === 'orderDetailDtoList'">
                <div v-for="(item,index) in scope.row.orderDetailDtoList" :key="index">
                  {{item.goodsAmount}} x {{item.goodsName}} {{item.goodsDetail}}
                </div>
              </div>
              <div v-else>{{scope.row[item.prop]}}</div>
            </template>
          </el-table-column>
          <el-table-column label="詳情" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="$router.push('/orderDetails?orderNum=' + scope.row.orderNum +'&status=problem')" type="text" >查看</el-button>
              <el-button
                @click= "completeOrder(scope.row.orderNum)"
                type= "text"
                v-if= "scope.row.isAccomplish==0"
                >完成</el-button>
              <el-button v-else type="text" style="color:#909090;">已完成</el-button>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="currentPageSize"
          :pager-count='5'
          layout="sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 查看詳情 -->
    <div v-if="detailsFlag"  class="propWrap">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title"><!---->
            <span>提示信息</span>
          </div>
          <button type="button" aria-label="Close" class="el-message-box__headerbtn">
            <i class="el-message-box__close el-icon-close" @click="detailsFlag=false"></i>
          </button>
        </div>
        <div class="el-message-box__content" style="display:block;">
          <el-form>
            <el-form-item label="問題類型 ：">
              <p>{{questionKind}}</p>
            </el-form-item>
            <el-form-item label="問題描述 ：">
              <textarea
                style="width: 80%;height: 80px;border: none;text-indent:-42px;margin-top:10px"
                readonly="">
              {{questionDescription}}</textarea>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 完成訂單 -->
    <div v-if="completeFlag"  class="propWrap completeProp ">
      <div class="el-message-box el-message-box--center">
        <div class="el-message-box__header">
          <div class="el-message-box__title"><!---->
            <span>提示信息</span>
          </div>
          <button type="button" aria-label="Close" class="el-message-box__headerbtn">
            <i class="el-message-box__close el-icon-close" @click="completeFlag=false"></i>
          </button>
        </div>
        <div class="el-message-box__content" style="display:block;">
          <el-form>
            <el-form-item label="訂單編號 ：">
              <p>{{orderNum}}</p>
            </el-form-item>
            <el-form-item label="用戶帳號 ：">
              <p>{{account}}</p>
            </el-form-item>
            <el-form-item label="真實姓名 ：">
              <p>{{realName}}</p>
            </el-form-item>
            <el-form-item label="聯繫郵箱 ：">
              <p>{{email}}</p>
            </el-form-item>
            <el-form-item label="問題類型 ：">
              <p>{{questionKind}}</p>
            </el-form-item>

          </el-form>
          <!-- <p style="color:red">* 订单问题确认完成后，订单状态会变更为【已完成】</p> -->
        </div>

        <div class="el-message-box__btns">
          <button @click="completeFlag=false" type="button" class="el-button el-button--default el-button--small">
            <span>取消</span>
          </button>
          <button @click="completeOptions()" type="button" class="el-button el-button--default el-button--small el-button--primary ">
            <span>確認</span>
          </button>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data () {
    return {
      navBlock: '訂單',
      navtitle: '問題訂單',
      orderList: [],
      listMenuForm:{
        userAccount: '',
        orderId: '',
        payWay: '',
        logisticsId: '',//貨運單號
        wrongType: '',//問題類型
      },
      orderTable: [
        {
          prop: 'questionKind',
          label: '問題類型',
          width: '100'
        },
        {
          prop: 'orderNum',
          label: '訂單編號',
          width: '170'
        },{
          prop: 'username',
          label: '訂購人',
          width: '170'
        },{
          prop: 'email',
          label: '聯繫郵箱',
          width: '130'
        },{
          prop: 'address',
          label: '收件地區',
          width: '150'
        },{
          prop: 'orderDetailDtoList',
          label: '品項',
          width: '280'
        },{
          prop: 'trackingNumber',
          label: '貨運單號',
          width: '140'
        },{
          prop: 'createTime',
          label: '創建時間',
          width: '150'
        },{
          prop: 'remark',
          label: '備註',
          width: '150'
        }
      ],
      currentPage: 1,
      currentPageSize: 20,
      total: 10,
      questionOption: [],
      fileList:[],
      detailsFlag: false,
      completeFlag: false,
      questionKind: '',
      questionDescription: '',
      orderNum: '',
      account: '',
      realName: '',
      email: '',
      dialogVisible: false,

    }
  },
  created () {
    let _this = this;
    // _this.getOrderList();
    _this.getWrongType();
  },
  activated(){
    let _this = this;
    _this.getOrderList();
    // if(_this.listMenuForm.userAccount === '' &&
    //     _this.listMenuForm.orderId === '' &&
    //     _this.listMenuForm.payWay === '' &&
    //     _this.listMenuForm.logisticsId === '' &&
    //     _this.listMenuForm.wrongType === '' &&
    //     _this.currentPage===1
    //   ){
    //     _this.getOrderList();
    //   }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 获取订单问题类型
    getWrongType(){
      let _this = this;
      _this.$get('/request/order/selectOrderQuestion',{},_this.$GLOBAL.jsonConfig)
        .then((res) => {
          if(res.code === '00000') {
            _this.questionOption = res.data.list;
          } else{
            _this.$propMessage(res.message,'error');
          }
        })
    },

    // 获取订单列表
    getOrderList(){
      let _this = this;
      console.log(_this.listMenuForm.wrongType)
      let param = {
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
        orderNum: _this.listMenuForm.orderId === '' ? null : _this.listMenuForm.orderId,
        username: _this.listMenuForm.userAccount === '' ? null : _this.listMenuForm.userAccount,
        payMethod: _this.listMenuForm.payWay=== '' ? null : _this.listMenuForm.payWay,
        trackingNumber: _this.listMenuForm.logisticsId === '' ? null : _this.listMenuForm.logisticsId,//货运编号
        problemType: _this.listMenuForm.wrongType === '' ? null : _this.listMenuForm.wrongType,
      }
      _this.$post('request/order/v2/getProblemOrderList', param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            _this.total = res.data.allRow;
            res.data.list.forEach( v => {
              // if(v.areaCode!==null){
              //   v.receivePhone = '+' + v.areaCode + ' ' + v.receivePhone
              // }
              v.area = ((v.country===null? '': v.country) + ' ' + (v.city===null? '' :v.city) + '').toString();
            });
            _this.orderList = res.data.list;
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message,'error',
              function(){
                _this.dialogVisible = false;
              });

          }
        })
    },
    // 分页
    handleCurrentChange(val){
      let _this = this;
      _this.currentPage = val;
      _this.getOrderList();
    },
    handleSizeChange(val){
      let _this = this;
      _this.currentPageSize = val;
      _this.getOrderList();
    },
    // 查詢
    search(){
      let _this = this
      if(_this.listMenuForm.logisticsId != '' && _this.listMenuForm.logisticsId.length < 8) {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入8-18個字符的貨運單號','error',
          function(){
            _this.dialogVisible = false;
          });

        return false;
      }
      _this.currentPage = 1;
      _this.getOrderList();
    },
    // 重置
    reset(){
      let _this = this;
      _this.listMenuForm={
        userAccount: '',
        orderId: '',
        payWay: '',
        logisticsId: '',
        wrongType: '',
      }
      _this.currentPage = 1;
      _this.getOrderList();
    },
    wrongDetails(kind, des){
      let _this = this;
      _this.detailsFlag = true;
      _this.questionKind = kind;
      _this.questionDescription = des;
    },
    completeOrder(orderNum){
      let _this = this;
      let completeDetails = []
      _this.orderList.forEach( v => {
        if (orderNum == v.orderNum){
          _this.questionKind = v.questionKind;
          _this.orderNum = v.orderNum;
          _this.account = v.username;
          _this.realName = v.realName;
          _this.email = v.email;
        }
      });
      _this.completeFlag = true;
    },
    completeOptions(){
      let _this = this;
      _this.$post(`/request/order/accomplish/status/${_this.orderNum}`, {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code==='00000') {
            _this.$propMessage('成功完成訂單', 'success',
              function(){
                _this.dialogVisible = false;
                _this.completeFlag = false;
                _this.getWrongType();
                _this.getOrderList();
              });

          } else {
            _this.$propMessage(res.message, 'error',
              function(){
                _this.dialogVisible = false;
              });
          }
        })
    },
    // 导出excel
    exportExcel(){
      let _this = this;
      if (_this.listMenuForm.orderId === '' && _this.listMenuForm.userAccount === '' &&  _this.listMenuForm.payWay === ''  &&
        _this.listMenuForm.trackingNumber === '' && _this.listMenuForm.questionId === '') {
          _this.dialogVisible = true;
          _this.$propMessage('請輸入至少一個導出條件','error',
            function(){
              _this.dialogVisible = false;
            });
          return false;
      };
      _this.downExcel();
    },
    // 下载excel
    downExcel(){
      let _this = this;
      let url = '/request/order/exportProblemOrderExcel';
      let data = {
        pageNo:1,
        pageSize:99999999,
        orderNum: _this.listMenuForm.orderId == '' ? null : _this.listMenuForm.orderId,
        payMethod: _this.listMenuForm.payWay == '' ? null : _this.listMenuForm.payWay,
        trackingNumber: _this.listMenuForm.logisticsId == '' ? null : _this.listMenuForm.logisticsId,
        problemType: _this.listMenuForm.wrongType == '' ? null : _this.listMenuForm.wrongType,
        username: _this.listMenuForm.userAccount == '' ? null : _this.listMenuForm.userAccount,
      }
      _this.$exportExcel(url, 'POST', data, '問題訂單');
    }
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
  .content{
    .paddingContent{
        width: 100%;
        .ListMenu{
            display: flex;
        }
        .downloadTableBtn{
          cursor: pointer;
          span{
            color:#fff;
            font-size: 0.12rem;
          }
        }
        .tableWrap {
            width: 100%;
            height: calc(100% - 152px);
            overflow: auto;
            word-break: break-all;
            .cell{
              height: 100%;
              p{
                width: 100%;
              }
              p:last-child{
                border-bottom: none;
              }
            }

            @media (max-width: 768px) {
            height: calc(100% - 92px);
            }

            @media (max-width: 420px) {
            height: calc(100% - 112px);
            }

        }
    }
    .propWrap {
      display: flex;
      justify-content: center;
      align-items: center;
      .el-message-box{
        height: 3.6rem;
      }
      .prop-content {
        height: 40%;
        overflow: auto;
        .icon-close{
          padding:0.2rem;
        }
      }
    }
    .completeProp{
      .el-message-box{
        height: 5.6rem;
        .el-message-box__content{
          margin: 0.3rem 0 0.3rem 0;
        }
      }
    }
}
@media screen and (min-width: 769px) {
    .ListMenu{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .searchForm{
            flex: 1;
            display: flex;
            justify-content: flex-start;
            .searchItem{
              margin-right: 0.4rem;
            }
        }
        .MenuBtnWrap{
            flex: 1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/wrongOrder/wrongOrder.vue